import { RouteType } from '@Pages/RetroSynthesis/constants';

export function routeLayoutNest(items, id = undefined, link = 'parentId') {
  return items.filter((item) => item[link] === id).map((item) => ({ ...item, children: routeLayoutNest(items, item.id) }));
}

export function routeLayoutPerformRouteName(routeType, id) {
  let name = "";
  switch (routeType) {
    case RouteType.PREDICTED:
      name = 'Predicted';
      break;
    case RouteType.PUBLISHED:
      name = 'Published';
      break;
    case RouteType.CUSTOMIZED:
      name = 'Customized';
      break;
  }
  return `${name} Route #${id}`;
}

export function routeLayoutGetMaxDepth(node, count) {
  return node.children.length ? Math.max(...node.children.map(child => routeLayoutGetMaxDepth(child, count))) + 1 : count;
}
